import { Component, Input, Output, EventEmitter, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';

export interface ColumnSettingsItem {
  key: string;
  label: string;
  visible: boolean;
  required?: boolean;
}

@Component({
    selector: 'pv-column-settings',
    templateUrl: './column-settings.component.html',
    styleUrls: ['./column-settings.component.scss'],
    standalone: false
})
export class ColumnSettingsComponent implements OnInit {
  @Input() columns: ColumnSettingsItem[] = [];
  @Input() storageKey: string = 'default';
  @Output() columnsChange = new EventEmitter<ColumnSettingsItem[]>();
  @Output() visibilityChanged = new EventEmitter<ColumnSettingsItem[]>();

  @ViewChild('columnSettingsModal', { static: true }) columnSettingsModal: TemplateRef<any>;

  constructor(private dialogService: NbDialogService) {}

  ngOnInit() {
    if (this.columns.length > 0) {
      this.loadColumnSettings();
    }
  }

  openModal() {
    this.dialogService.open(this.columnSettingsModal, {
      context: {
        columns: this.columns
      },
      closeOnBackdropClick: true,
      closeOnEsc: true
    });
  }

  toggleColumn(column: ColumnSettingsItem) {
    if (!column.required) {
      column.visible = !column.visible;
      this.updateSettings();
    }
  }

  showAllColumns() {
    this.columns.forEach(col => col.visible = true);
    this.updateSettings();
  }

  hideAllColumns() {
    this.columns.forEach(col => {
      if (!col.required) {
        col.visible = false;
      }
    });
    this.updateSettings();
  }

  private updateSettings() {
    this.saveColumnSettings();
    this.emitChanges();
  }

  private emitChanges() {
    this.columnsChange.emit(this.columns);
    this.visibilityChanged.emit(this.columns);
  }

  private saveColumnSettings() {
    const storageKey = this.getStorageKey();
    const settings = this.columns.map(col => ({
      key: col.key,
      visible: col.visible
    }));
    localStorage.setItem(storageKey, JSON.stringify(settings));
  }

  private loadColumnSettings() {
    const storageKey = this.getStorageKey();
    const saved = localStorage.getItem(storageKey);
    
    if (saved) {
      try {
        const settings = JSON.parse(saved);
        this.applySettings(settings);
        this.emitChanges();
      } catch (e) {
        console.warn('Failed to load column settings:', e);
      }
    }
  }

  private applySettings(settings: any[]) {
    settings.forEach(setting => {
      const column = this.columns.find(col => col.key === setting.key);
      if (column) {
        column.visible = setting.visible;
      }
    });
  }

  private getStorageKey(): string {
    return `columnSettings_${this.storageKey}`;
  }
}
